module.exports = __webpack_public_path__ + "static/media/carousel5.7e61e934.jpeg";